export * from "/codebuild/output/src2357269973/src/auction-chase-frontend/node_modules/react-icons/fc/index.mjs"